import React from "react";

export default function OriginalIcon() {
    return <svg xmlns="http://www.w3.org/2000/svg" width="16.057" height="14.331" viewBox="0 0 16.057 14.331">
        <g id="Gruppe_87" data-name="Gruppe 87" transform="translate(0)">
            <text id="OG" transform="translate(8 10.02)" fill="currentColor" fontSize="8" fontFamily="AlbertSans-Bold, Albert Sans" fontWeight="700"><tspan x="-6.168" y="0">OG</tspan></text>
            <g id="Rechteck_205" data-name="Rechteck 205" transform="translate(0 0)" fill="none" stroke="currentColor" strokeWidth="1.15">
            <rect width="16.057" height="14.331" rx="1.6" stroke="none"/>
            <rect x="0.575" y="0.575" width="14.907" height="13.181" rx="1.025" fill="none"/>
            </g>
        </g>
    </svg>;
}